import React from "react";
import Layout from "../../Component/Layout";
import { TILE_REGISTRY } from "../../Component/Favourite/TileRegistry";
import PinToHome from "../../Component/Favourite/PinToHome";
import { useNavigate } from "react-router-dom";

const MasterDataHome = () => {

  const navigate = useNavigate();

  // ✅ ONLY Product Master Data tile
  const cards = [
  TILE_REGISTRY.PRODUCT_MASTER_DATA,
  TILE_REGISTRY.SALES_CHECKLIST,
  TILE_REGISTRY.TERMS_CONFIG
];

  const handleNavigate = (path) => {
    navigate(path);
  };

  return (
    <Layout>
      <div style={{ padding: "30px 40px", backgroundColor: "#f8fafc", minHeight: "calc(100vh - 60px)" }}>

        {/* Header */}
        <div style={{ marginBottom: "35px" }}>
          <h2 style={{ margin: "0 0 8px 0", color: "#0f172a", fontWeight: "700", fontSize: "28px" }}>
            Master Data
          </h2>
          <p style={{ color: "#64748b", margin: 0, fontSize: "15px" }}>
            Manage all master data configurations.
          </p>
        </div>

        {/* Tiles */}
        <div
          style={{
            display: "grid",
            gridTemplateColumns: "repeat(auto-fill, minmax(260px, 1fr))",
            gap: "24px",
          }}
        >
          {cards.map((item) => {
            const IconComponent = item.icon;

            return (
              <div
                key={item.id}
                style={{
                  background: "#ffffff",
                  borderRadius: "16px",
                  border: "1px solid #e2e8f0",
                  boxShadow: "0 4px 6px -1px rgba(0,0,0,0.05)",
                  padding: "24px",
                  cursor: "pointer",
                  display: "flex",
                  flexDirection: "column",
                  height: "160px",
                  transition: "all 0.3s ease"
                }}
                onClick={() => handleNavigate(item.path)}
                onMouseEnter={(e) => {
                  e.currentTarget.style.transform = "translateY(-6px)";
                  e.currentTarget.style.boxShadow = "0 20px 25px -5px rgba(0,0,0,0.1)";
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.transform = "translateY(0)";
                  e.currentTarget.style.boxShadow = "0 4px 6px -1px rgba(0,0,0,0.05)";
                }}
              >
                {/* Icon + Pin */}
                <div style={{ display: "flex", justifyContent: "space-between", marginBottom: "auto" }}>
                  <div style={{
                    background: "linear-gradient(135deg, #eff6ff, #dbeafe)",
                    color: "#3b82f6",
                    padding: "14px",
                    borderRadius: "12px"
                  }}>
                    <IconComponent size={26} />
                  </div>

                  <PinToHome tileId={item.id} />
                </div>

                {/* Text */}
                <div>
                  <h5 style={{ fontSize: "16px", fontWeight: "600", margin: "0 0 6px 0" }}>
                    {item.name}
                  </h5>
                  <p style={{ fontSize: "13px", color: "#64748b", margin: 0 }}>
                    Open Module →
                  </p>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </Layout>
  );
};

export default MasterDataHome;